// Global Cart Timer for Windfall Store
console.log('🚀 GLOBAL CART TIMER LOADING');

class WindfallCartTimer {
  constructor() {
    this.isRunning = false;
    this.startTime = null;
    this.duration = 600; // 10 minutes in seconds
    this.tickInterval = 2000; // 2 real seconds per timer second
    this.animationId = null;
    this.storageKey = 'windfall_cart_timer';
    
    console.log('⚡ WindfallCartTimer initialized');
    this.loadFromStorage();
    this.bindEvents();
  }
  
  loadFromStorage() {
    try {
      const saved = localStorage.getItem(this.storageKey);
      if (saved) {
        const data = JSON.parse(saved);
        console.log('💾 Found saved timer data:', data);
        
        if (data.expired) {
          console.log('⏰ Timer was already expired');
          this.showExpiredMessage();
          return;
        }
        
        if (data.startTime) {
          const now = Date.now();
          const totalElapsed = now - data.startTime;
          const timerElapsed = Math.floor(totalElapsed / this.tickInterval);
          const remaining = Math.max(0, this.duration - timerElapsed);
          
          if (remaining > 0) {
            console.log('▶️ Resuming timer with', remaining, 'seconds remaining');
            this.startTime = data.startTime;
            this.isRunning = true;
            this.updateDisplay();
          } else {
            console.log('⏰ Timer expired while away');
            this.saveToStorage({ expired: true });
            this.showExpiredMessage();
          }
        }
      } else {
        console.log('📭 No saved timer found');
      }
    } catch (e) {
      console.log('❌ Error loading timer data:', e);
    }
  }
  
  saveToStorage(data = null) {
    try {
      const saveData = data || {
        startTime: this.startTime,
        expired: false
      };
      localStorage.setItem(this.storageKey, JSON.stringify(saveData));
      console.log('💾 Timer data saved');
    } catch (e) {
      console.log('❌ Could not save timer data:', e);
    }
  }
  
  bindEvents() {
    // Listen for cart additions - multiple ways to catch this
    document.addEventListener('DOMContentLoaded', () => {
      console.log('📄 DOM loaded, setting up timer listeners');
      
      // Method 1: Listen for Shopify cart events
      if (window.Shopify && window.Shopify.onItemAdded) {
        const originalOnItemAdded = window.Shopify.onItemAdded;
        window.Shopify.onItemAdded = (...args) => {
          console.log('🛒 Shopify onItemAdded triggered');
          originalOnItemAdded.apply(this, args);
          setTimeout(() => this.startTimer(), 500);
        };
      }
      
      // Method 2: Watch for cart drawer opening AND new items being added
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Look for cart popup/drawer elements
              if (node.querySelector && 
                  (node.querySelector('.cart-timer-container') || 
                   node.querySelector('.quick-buy-drawer__info'))) {
                console.log('🎯 Cart popup detected, starting timer');
                setTimeout(() => this.startTimer(), 100);
              }
              
              // Look for cart drawer being opened
              if (node.id === 'cart-drawer' || node.querySelector('#cart-drawer')) {
                console.log('🛒 Cart drawer opened, syncing timer');
                setTimeout(() => this.updateDisplay(), 100);
              }
            }
          });
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      console.log('👀 MutationObserver set up');
    });
  }
  
  startTimer() {
    if (this.isRunning) {
      console.log('⏸️ Timer already running, restarting...');
      // Stop current timer and restart fresh
      this.isRunning = false;
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
    }
    
    console.log('▶️ Starting new 10-minute timer');
    this.isRunning = true;
    this.startTime = Date.now();
    this.saveToStorage(); // Save immediately when starting
    this.updateDisplay();
  }
  
  updateDisplay() {
    const now = Date.now();
    const elapsed = now - this.startTime;
    const timerElapsed = Math.floor(elapsed / this.tickInterval);
    const remaining = Math.max(0, this.duration - timerElapsed);
    
    // Find ALL timer elements (popup, cart drawer, AND main cart)
    const countdownElements = document.querySelectorAll('#timer-countdown, #timer-countdown-drawer, #timer-countdown-cart, .cart-timer-display');
    const messageElements = document.querySelectorAll('#timer-message, #timer-message-drawer, #timer-message-cart, .cart-timer-message');
    const containerElements = document.querySelectorAll('.cart-timer-container');
    
    if (countdownElements.length === 0) {
      console.log('❌ No timer elements found, retrying in 1 second');
      setTimeout(() => {
        if (this.isRunning) {
          this.updateDisplay();
        }
      }, 1000);
      return;
    }
    
    if (remaining === 0) {
      console.log('⏰ TIMER EXPIRED!');
      this.showExpiredMessage();
      this.isRunning = false;
      return;
    }
    
    const timeString = this.formatTime(remaining);
    console.log(`⏱️ Timer: ${timeString} (${Math.floor(elapsed/1000)}s elapsed)`);
    
    // Update ALL countdown displays (popup + cart drawer + main cart)
    countdownElements.forEach(el => {
      el.textContent = timeString;
    });
    
    // Continue updating
    this.animationId = requestAnimationFrame(() => this.updateDisplay());
  }
  
  showExpiredMessage() {
    const messageElements = document.querySelectorAll('#timer-message, #timer-message-drawer, #timer-message-cart, .cart-timer-message');
    const containerElements = document.querySelectorAll('.cart-timer-container');
    
    messageElements.forEach(el => {
      el.innerHTML = `<span style="color: #2e7d32; font-weight: 500;">Bonus unlocked! Use code</span>
                     <span style="font-weight: 700; color: #1b5e20; background: linear-gradient(135deg, #e8f5e8, #f1f8e9); padding: 4px 10px; border-radius: 6px; border: 1px solid #c8e6c9; margin: 0 4px;">LAST5</span>
                     <span style="color: #2e7d32; font-weight: 500;">for 5% off</span>`;
    });
    
    containerElements.forEach(el => {
      el.style.background = 'linear-gradient(135deg, #f1f8e9, #e8f5e8)';
      el.style.borderColor = '#c8e6c9';
    });
    
    // Save expired state
    this.saveToStorage({ expired: true });
  }
  
  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return mins.toString().padStart(2, '0') + ':' + secs.toString().padStart(2, '0');
  }
  
  // Public method to manually start timer (resets completely)
  manualStart() {
    console.log('🔧 Manual timer start triggered - clearing saved data');
    localStorage.removeItem(this.storageKey); // Clear any saved timer
    this.startTime = Date.now();
    this.isRunning = true;
    this.saveToStorage();
    this.updateDisplay();
  }
}

// Initialize the global timer
window.windfallTimer = new WindfallCartTimer();

// Also expose a simple function to start the timer manually
window.startCartTimer = () => {
  console.log('🎮 Manual start function called');
  window.windfallTimer.manualStart();
};

console.log('✅ Global cart timer system ready');